import { findFakePhoneReason, isPhoneMissing } from '@shared/phone-quality';

export const BOOKING_PHONE_REQUIRED_MESSAGE =
  "Add the customer's phone number to book, or tick “Customer won't share a number”.";
export const BOOKING_PHONE_FAKE_MESSAGE = "That doesn't look like a real phone number.";

export type BookingPhoneDecision =
  | { ok: true; phoneToSave: string | null }
  | { ok: false; message: string };

/**
 * Booking a design call or site visit is when staff have almost certainly
 * spoken to the customer, so a missing number is asked for here. A customer
 * who refuses can still be booked; the record stays visibly "Phone missing".
 */
export function decideBookingPhone(input: {
  currentPhone: string | null | undefined;
  enteredPhone: string;
  declined: boolean;
}): BookingPhoneDecision {
  if (!isPhoneMissing(input.currentPhone)) return { ok: true, phoneToSave: null };
  if (input.declined) return { ok: true, phoneToSave: null };
  const entered = input.enteredPhone.trim();
  if (!entered) return { ok: false, message: BOOKING_PHONE_REQUIRED_MESSAGE };
  if (findFakePhoneReason(entered)) return { ok: false, message: BOOKING_PHONE_FAKE_MESSAGE };
  return { ok: true, phoneToSave: entered };
}
